// extracted by mini-css-extract-plugin
export default {"root":"ImageContentSection_root-QQT","container":"ImageContentSection_container-mDo","image":"ImageContentSection_image-jZr","content":"ImageContentSection_content-cMY"};